module.exports = __webpack_public_path__ + "img/k15.55786aa7.jpg";